module.exports = __webpack_public_path__ + "img/6.8af8ce2a.jpg";